import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.atlas.semantic.color.surface.variant};
`;

export const Label = styled.label`
  padding: 9px 16px;
  min-width: 150px;
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-size: 14px;
  font-weight: 400;
  background-color: ${({ theme }) =>
    theme.atlas.semantic.color.surface.default};
  color: ${({ theme }) => theme.atlas.semantic.color.type.disabled};
`;

export const Input = styled.input`
  display: none;
  &:checked + ${Label} {
    background-color: ${({ theme }) =>
      theme.atlas.semantic.color.action.primary.default};
    color: ${({ theme }) =>
      theme.atlas.semantic.color.action.primary.onPrimary};
  }
`;
